module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ADzgmN/tc-custom/9781250160317.jpg?1737775153119",
      "alt": "This image is the cover for the book The Lighten Up Cookbook, RecipeLion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Lighten Up Cookbook, RecipeLion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Classic American dishes get a lighter makeover in "), _c('i', [_vm._v("The Lighten Up Cookbook")]), _vm._v(" by Cutthroat Kitchen star Addie Gundry, from nutrient-rich smoothies to easy family dinners to guilt-free desserts.")]), _c('br'), _c('br'), _vm._v("Eating lighter doesn’t have to include charts or calorie counting. By incorporating easy healthy recipes into your diet, like substituting cauliflower for starchy breads or baking chicken instead of frying it, you can revitalize your eating habits without giving up the foods you love. From light breakfast recipes like the Kale Smoothie to potluck favorites like Mayo-Free Chicken Salad to family dinners like Zucchini Lasagna and even sweet treats like Pineapple Fluff, eating healthier can be simple and tasty! Each recipe is paired with a gorgeous full-color finished-dish photo.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Addie Gundry\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Griffin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0